import Skeleton from "common/components/ui/Skeleton";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import type { JSX } from "react";

export default function CampaignInfoLoader() {
  const isDesktop = useTwBreakpoint("lg");

  const stateTag = <Skeleton className="h-6 w-16" />;
  const workerAccountsTag = <Skeleton className="h-6 w-32 rounded-full" />;
  const actionsDropdown = <Skeleton className="size-8 rounded-full" />;
  const campaignName = <Skeleton className="h-5 w-40" />;
  const campaignTypeIcon = (
    <Skeleton className="size-10 shrink-0 rounded-2xl" />
  );
  const typeAndSubtype = (
    <div className="flex w-full items-center gap-x-1 text-black-500">
      <Skeleton className="size-4 shrink-0" />
      <Skeleton className="inline-flex h-4 w-full max-w-40 lg:w-40" />
    </div>
  );

  let mainContent: JSX.Element;
  if (isDesktop) {
    mainContent = (
      <>
        {campaignTypeIcon}

        <div className="ml-2.5">
          <div className="flex items-center gap-x-1.5">
            {campaignName}
            {stateTag}
          </div>

          {typeAndSubtype}
        </div>

        <div className="flex flex-1 items-center justify-end gap-x-2.5">
          <div className="flex items-center gap-x-1">
            <span className="text-xs text-black-500">Run by:</span>
            {workerAccountsTag}
          </div>
          <span className="h-8 w-px bg-black-200" />
          {actionsDropdown}
        </div>
      </>
    );
  } else {
    mainContent = (
      <>
        <div className="flex w-full gap-x-2.5">
          {campaignTypeIcon}

          <div className="flex grow flex-col gap-y-1">
            {campaignName}
            {typeAndSubtype}
          </div>

          <span className="h-8 w-px bg-black-200" />
          {actionsDropdown}
        </div>

        {/* Divider */}
        <span className="my-2 h-px w-full bg-black-200" />

        <div className="flex w-full items-center justify-between gap-x-2">
          <div className="flex items-center gap-x-1">
            <span className="text-xs text-black-500">Run by:</span>
            {workerAccountsTag}
          </div>

          {stateTag}
        </div>
      </>
    );
  }

  return (
    <section className="mb-4 flex flex-col rounded-3xl border border-black-200 p-3 lg:flex-row lg:items-center">
      {mainContent}
    </section>
  );
}
